import { NiUtils } from "src/app/mockup/utils/ni";
import { BloqueioManualDto } from "./bloqueio-manual-dto";
import { BloqueioRestituicaoDto } from "./bloqueio-restituicao-dto";

export type Bloqueio = BloqueioManualDto | BloqueioRestituicaoDto;

export function isBloqueioManualDto(bloqueio: Bloqueio): bloqueio is BloqueioManualDto {
  return "numeroDocumento" in bloqueio;
}

export function isBloqueioRestituicaoDto(bloqueio: Bloqueio): bloqueio is BloqueioRestituicaoDto {
  return "blppPgtoNr" in bloqueio;
}

export class ReservaBloqueio {
  public numeroDocumento: string;
  public valorReservado: number;
  public valorBloqueado: number;
  public sistema: string;
  public processo: string;
  public motivoBloqueio: string;
  public cpfUsuario: string;

  constructor(bloqueio: Bloqueio) {
    if (isBloqueioManualDto(bloqueio)) {
      this.numeroDocumento = bloqueio.numeroDocumento;
      this.valorReservado = 0;
      this.valorBloqueado = bloqueio.valorBloqueado;
      this.sistema = "RDOC";
      this.processo = bloqueio.processo;
      this.motivoBloqueio = bloqueio.motivoBloqueio;
      this.cpfUsuario = NiUtils.obterNiCompleto(bloqueio.cpfResponsavel, "cpf");
    } else {
      this.numeroDocumento = bloqueio.blppPgtoNr.toString();
      this.valorReservado = bloqueio.blppVlReservado;
      this.valorBloqueado = bloqueio.blppVlBloqueado ?? 0;
      this.sistema = "SCC";
      this.processo = bloqueio.blppBPerdcomp;
    }
  }
}